import type { ConnectionStatus } from "@kalaporssi/client";
import type { PublicPlayer } from "@kalaporssi/shared";
import { Link } from "react-router";
import { feur, MSHORT, monthName } from "../lib/format";

/** The auction-board header: brand, month strip and running standings. */
export function Board(props: {
  /** -1 = no game, 0..11 = current month, 12 = finished. */
  month?: number;
  players?: PublicPlayer[];
  connection?: ConnectionStatus;
}) {
  const m = props.month ?? -1;
  const ranked = [...(props.players ?? [])].filter((p) => p.active || p.total > 0).sort((a, b) => b.total - a.total);
  return (
    <header className="board">
      <div className="bar">
        <Link to="/" className="mark">
          Kalapörssi<small>Itämeren saaliit, yksi kuukausi kerrallaan</small>
        </Link>
        <div className="months" role="img" aria-label={m >= 0 && m < 12 ? `Kuukausi: ${monthName(m)}` : "Kuukaudet"}>
          {MSHORT.map((x, i) => (
            <span key={monthName(i)} className={i < m ? "done" : i === m ? "now" : ""} title={monthName(i)}>
              {x}
            </span>
          ))}
        </div>
        {ranked.length > 0 && m >= 0 && (
          <div className="stand">
            {ranked.map((p) => (
              <span key={p.id}>
                {p.nickname} <b>{feur(p.total)}</b>
              </span>
            ))}
          </div>
        )}
        {props.connection === "disconnected" && (
          <span className="conn" role="status">
            Yhteys katkennut, päivitetään muutaman sekunnin välein…
          </span>
        )}
      </div>
    </header>
  );
}
